import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './root-reducer'

const configureStore = () => {
  const initialState = {}
  const middleware = [thunk]

  const store = createStore(
    rootReducer,
    initialState,
    compose(applyMiddleware(...middleware))
  )

  return store
}

export default configureStore
